<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="padding-top: 0">
      <a-tabs :default-active-key="tabKey" @change="handleTabChange">
        <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
          <TableList
            :columns="columns"
            :tableData="dataSource"
            bordered
            :loading="loading"
            :scroll="tableScroll"
            :pagination="ipagination"
            @change="handleTableChange"
            style="min-height: 350px"
            class="care-situation-table"
          >
            <div slot="queryArea" class="query-area">
              <div>
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择年级"
                  v-model="queryParam.gradeId"
                  dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                  :isShowEmpty="false"
                  @select="$set(queryParam, 'classId', undefined)"
                  @clear="$set(queryParam, 'classId', undefined)"
                />
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择班级"
                  v-model="queryParam.classId"
                  :dictCode="
                    'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                  "
                  :async="true"
                  :disabled="!queryParam.gradeId"
                  :isShowEmpty="false"
                />
                <a-range-picker
                  v-model="dateRange"
                  class="search-space"
                  style="width: 240px"
                  @change="changeDateRange"
                />
                <j-dict-select-tag
                  v-model="queryParam.careList"
                  placeholder="关爱等级"
                  dictCode="care_list"
                  class="search-space"
                />
                <a-input-search
                  v-model="queryParam.studentName"
                  placeholder="请输入学生名字"
                  class="search-space"
                  style="width: 170px"
                  @change="searchName"
                />
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 15px"
                >
                  重置
                </a-button>
              </div>
              <a-button
                type="primary"
                icon="download"
                :laoding="exportXlsLoading"
                style="margin-left: auto"
                :disabled="dataSource.length == 0"
                @click="handleExportXls(item.tab)"
              >
                导出
              </a-button>
            </div>
            <span slot="weekRemind" slot-scope="{ record }">
              <img
                v-if="record.weekRemind == '1'"
                src="@/assets/imgs/commonPage/remind.png"
                alt=""
                style="width: 20px; height: 20px"
              />
              <span v-else>未提醒</span>
            </span>
            <template slot="action" slot-scope="{ record }">
              <div class="action-detail">
                <template v-if="identityId == 6">
                  <!-- <span v-if="tabKey == 1" :style="{ color: '#0077fa' }" @click="reported(record)">
                    上报
                  </span> -->
                  <!-- <a-divider v-if="tabKey == 1" type="vertical" /> -->
                  <!-- <span v-if="tabKey == 1" @click="homeSchoolCom(record)">家校沟通</span> -->
                  <!-- <span v-if="tabKey == 2" @click="viewTutorRecord(record)">添加干预记录</span>
                  <a-divider type="vertical" /> -->
                </template>
                <span @click="addVisitRecord(record)" class="action-span">添加家访记录</span>
                <br />
                <span @click="viewArchives(record)" class="action-span">查看档案</span>
                <span @click="addLedger(record)" class="action-span">添加台账</span>
              </div>
            </template>
          </TableList>
        </a-tab-pane>
      </a-tabs>
      <!-- 对话框 -->
      <ReportModal ref="reportModalRef" @refreshData="loadData" />
      <!-- 辅导台账 -->
      <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData" />
      <!-- 添加家访记录 -->
      <AddVisitRecordModal ref="visitRecordModalRef" @refreshData="loadData" />
      <SchoolHomeComModal ref="schoolHomeComModalRef" />
      <!--<MentoringRecordModal ref="mentoringRecordModalRef" @refreshData="loadData" />-->
      <AddInterveneRecord ref="interveneRecordRef" @refreshData="loadData" />
    </div>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction, postAction } from '@api/manage'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Breadcrumb from '@/components/Breadcrumb/index'
import ReportModal from '@/comUi/ReportModal.vue'
import SchoolHomeComModal from '@/comUi/SchoolHomeComModal.vue'
import MentoringRecordModal from '@/comUi/MentoringRecordModal.vue'
import AddInterveneRecord from '@/comUi/AddInterveneRecord.vue'
import AddLedgerModal from '@/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal'
import AddVisitRecordModal from '@/views/school/mentalHealth/CrisisIntervent/components/AddVisitRecordModal'
import { getWeekDateRange, getMonthDateRange, formatYearMonthDate } from '@/utils/date'
// vuex映射
import { mapGetters } from 'vuex'

export default {
  name: 'MainStuCareSituation',
  components: {
    Breadcrumb,
    TableList,
    ReportModal,
    SchoolHomeComModal,
    MentoringRecordModal,
    AddInterveneRecord,
    AddLedgerModal,
    AddVisitRecordModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 2,
      dateRange: [],
      disableMixinCreated: true,
      commonType: '',
    }
  },
  created() {
    this.setDate()
    this.commonType = this.$route.query?.commonType
    this.queryParam.role = this.identityId
    this.tabKey = this.$route.query?.index
    this.queryParam.queryTutorType = this.tabKey
    this.loadData(1)
  },
  computed: {
    ...mapGetters(['identityId']),
    columns() {
      const commonColumns = [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 70,
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
          width: 120,
        },
        {
          title: '学生',
          dataIndex: 'studentName',
          align: 'center',
          width: 120,
          // 移除宽度，使其在待关爱页签下成为弹性列
        },
        {
          title: '关爱等级',
          dataIndex: 'careList_dictText',
          align: 'center',
          width: 120,
        },
        {
          title: '辅导次数',
          dataIndex: 'tutorCount',
          align: 'center',
          width: 120,
          customRender: (text) => text || 0,
        },
        {
          title: '本学期提醒次数',
          dataIndex: 'semesterRemindCount',
          align: 'center',
          width: 150,
          minWidth: 140,
          customRender: (text) => text || 0,
        },
      ]
      return [
        ...commonColumns,
        {
          title: '辅导时间',
          dataIndex: 'tutorTime',
          align: 'center',
          width: 150,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '辅导类型',
          dataIndex: 'tutoringType_dictText',
          align: 'center',
          width: 150,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '辅导方法',
          dataIndex: 'tutoringMethod_dictText',
          align: 'center',
          width: 150,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '问题原因',
          dataIndex: 'psychologyIssues_dictText',
          align: 'center',
          width: 180,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '下一步措施',
          dataIndex: 'nextIntervention_dictText',
          align: 'center',
          width: 200,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '效果反馈',
          dataIndex: 'effectFeedback_dictText',
          align: 'center',
          width: 180,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '是否反馈校领导',
          dataIndex: 'feedbackFlag',
          align: 'center',
          width: 180,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '校领导名称',
          dataIndex: 'leaderName',
          align: 'center',
          width: 180,
          customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
        },
        {
          title: '具体情况说明',
          dataIndex: 'specificInstructions',
          align: 'center',
          width: 300,
          customRender: (text, record) => {
            const rawVal = text || record.comment || record.remark || ''
            if (!rawVal) return '--'
            // 移除 HTML 标签以便在 Tooltip 中显示纯文本
            const cleanVal = rawVal.replace(/<[^>]+>/g, '')
            return cleanVal.length >= 30 ? (
              <a-tooltip>
                <template slot="title">{cleanVal}</template>
                <div class="wrap-text">{cleanVal.substring(0, 30) + '...'}</div>
              </a-tooltip>
            ) : (
              <div class="wrap-text">{cleanVal}</div>
            )
          },
        },
        {
          title: '心理老师',
          dataIndex: 'teacherName',
          align: 'center',
          width: 100,
          customRender: (text) => text || '--',
        },
        {
          title: '处理时间',
          dataIndex: 'dealTime',
          align: 'center',
          width: 150,
          customRender: (text) => text || '--',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    tableScroll() {
      // 如果是已关爱页签（列很多），设置较大的固定宽度开启横向滚动
      // 如果是待关爱页签（列较少），设置 x: true 让其自适应容器宽度
      return { x: 2200 }
    },
    // 面包屑列表
    breadcrumbList() {
      if (this.commonType == 'counseling') {
        return [
          {
            label: '心理工作概览',
            isBack: true,
          },
          {
            label: '辅导记录',
          },
        ]
      } else if (this.commonType == 'crisis') {
        return [
          {
            label: '心理工作概览',
            isBack: true,
          },
          {
            label: '危机上报',
          },
        ]
      }
    },
    // tab列表配置
    tabPaneConfig() {
      if (this.commonType == 'counseling') {
        return [
          {
            tab: '提醒辅导记录',
            key: 2,
          },
          {
            tab: '自主辅导记录',
            key: 1,
          },
        ]
      } else if (this.commonType == 'crisis') {
        return [
          {
            tab: '提醒学生上报',
            key: 4,
          },
          {
            tab: '自主辅导上报',
            key: 3,
          },
        ]
      }
    },
    url() {
      return {
        list: '/schoolCounselingRecord/queryTutoringRecordPage',
        exportXlsUrl: '/schoolCounselingRecord/queryTutoringRecordPageExport',
      }
    },
  },
  methods: {
    setDate() {
      const beginDateQuery = this.$route.query?.beginDate
      const endDateQuery = this.$route.query?.endDate
      if (beginDateQuery && endDateQuery) {
        this.dateRange = [formatYearMonthDate(beginDateQuery), formatYearMonthDate(endDateQuery)]
        this.queryParam.beginDate = this.dateRange[0]
        this.queryParam.endDate = this.dateRange[1]
      }
    },
    addLedger(row) {
      this.$refs.addLedgerModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
    // 添加家访记录
    addVisitRecord(row) {
      this.$refs.visitRecordModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
    handleTabChange(key) {
      this.queryParam = {
        beginDate: this.dateRange[0],
        endDate: this.dateRange[1],
        role: this.identityId,
      }
      this.tabKey = key
      this.queryParam.queryTutorType = key
      this.loadData(1)
    },
    changeDateRange(dateArr) {
      this.queryParam.beginDate = dateArr?.[0] && moment(dateArr[0]).format('YYYY-MM-DD')
      this.dateRange[0] = dateArr?.[0] && moment(dateArr[0]).format('YYYY-MM-DD')
      this.queryParam.endDate = dateArr?.[1] && moment(dateArr[1]).format('YYYY-MM-DD')
      this.dateRange[1] = dateArr?.[1] && moment(dateArr[1]).format('YYYY-MM-DD')
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value
      this.loadData(1)
    }, 800),
    // 重置
    searchReset() {
      this.dateRange = []
      this.queryParam = {
        beginDate: '',
        endDate: '',
        role: this.identityId,
      }
      this.queryParam.queryTutorType = this.tabKey
      this.loadData(1)
    },
    viewTutorRecord(record) {
      this.$refs.interveneRecordRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
    reported(record) {
      this.$refs.reportModalRef.showModal(record)
    },
    homeSchoolCom(record) {
      this.$refs.schoolHomeComModalRef.showModal(record)
    },
    // mentoringRecord(record) {
    //   if (record?.warnStatus == 3 || record?.warnStatus == 4) {
    //     this.$refs.mentoringRecordModalRef.showModal(record)
    //   }
    // },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}

.search-space {
  width: 140px;
  margin-right: 15px;
}
.action-span {
  display: inline-block;
  margin-right: 10px;
  color: #0077fa;
}

.care-situation-table /deep/ .ant-table-tbody > tr > td {
  white-space: normal !important;
  word-break: break-all;
}

.wrap-text {
  white-space: normal;
  word-break: break-all;
  text-align: center;
}
</style>
